import { messageOf } from '@/api/errors';

/** Firebase's error codes, in words a person can act on. */
export function authMessage(e: unknown): string {
  const code = (e as { code?: string })?.code ?? '';
  if (code.includes('popup-closed') || code.includes('cancelled-popup')) return '';
  if (code.includes('invalid-credential') || code.includes('wrong-password') || code.includes('user-not-found'))
    return 'That email and password do not match an account.';
  if (code.includes('email-already-in-use')) return 'An account already uses that email. Sign in instead.';
  if (code.includes('weak-password')) return 'Choose a password of at least 8 characters.';
  if (code.includes('too-many-requests')) return 'Too many attempts. Wait a moment and try again.';
  if (code.includes('popup-blocked')) return 'Your browser blocked the sign-in window. Allow pop-ups for this site.';
  if (code.includes('unauthorized-domain'))
    return 'This address is not yet authorised for sign-in (Firebase Auth → Authorised domains).';
  if (code.includes('operation-not-allowed')) return 'This sign-in method is not enabled for the project.';
  // An unmapped Firebase code is named: "something went wrong" cannot be acted on, the code can.
  if (code.startsWith('auth/')) return `Sign-in failed (${code}).`;
  return messageOf(e);
}
